import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-toastify/dist/ReactToastify.css';

import 'mutation-events';

import 'bootstrap';

import '@fullcalendar/react/dist/vdom';

import '@grapecity/wijmo.touch';
import '@grapecity/wijmo.cultures/wijmo.culture.ja';

import '../scss/common.scss';
import '../viewportCorrector';

import React from 'react';
import ReactDOM from 'react-dom';

import { ToastContainer } from 'react-toastify';

import * as Wj from '@grapecity/wijmo';

import * as Consts from '../consts';
import { ToastContainerPreset } from '../consts';

import { Login } from './Login';

Wj.setLicenseKey(Consts.WJ_LICENSE);

ReactDOM.render(
  <>
    <header className="fixed-top"></header>

    <main role="main">
      <Login />
    </main>

    <ToastContainer enableMultiContainer={true} containerId={ToastContainerPreset.Common} position="top-center" />
  </>,
  document.getElementById('login')
);
